import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GOODWILL_CONSTANT } from '../utils/constant';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient, private router: Router) { }

    /*post call*/
    public post(url: string, body: any, options?: any) {      //sagai
        const finalURL = GOODWILL_CONSTANT.API_ENDPOINT + url;
        return this.http.post(finalURL, body, options);
    }


    // Method to call a GET request for Token API only
    public getCallForToken(url: string, token: any): Observable<any> { 
      let finalURL = GOODWILL_CONSTANT.API_ENDPOINT + url;
      let options = {
        headers: {
            token: `bearer ${token}` ,
            'Content-Type': `application/json ; charset=utf-8` ,

        }
      }
      return this.http.get(finalURL, options);
    }

}
